import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";
import {
  InterviewJourneyPlanResponse,
  GenerateResponse,
  JobStatusResponse,
} from "../types/interviewJourney";

class InterviewJourneysService {
  private getAuthHeaders(): object {
    return {
      Authorization: getAuthUser()?.accessToken,
    };
  }

  async generatePlan(
    interviewText: string,
    blueprintId: number
  ): Promise<InterviewJourneyPlanResponse> {
    const response = await axios.post(
      `${getApiUrlWithVersion()}/interview_journeys/plan`,
      { interview_text: interviewText, blueprint_id: blueprintId },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async generate(
    interviewText: string,
    blueprintId: number,
    plan: InterviewJourneyPlanResponse
  ): Promise<GenerateResponse> {
    const response = await axios.post(
      `${getApiUrlWithVersion()}/interview_journeys/generate`,
      {
        interview_text: interviewText,
        blueprint_id: blueprintId,
        plan,
      },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async getStatus(jobId: string): Promise<JobStatusResponse> {
    const response = await axios.get(
      `${getApiUrlWithVersion()}/interview_journeys/status/${jobId}`,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }
}

const interviewJourneysService = new InterviewJourneysService();
export default interviewJourneysService;
